const initialState = {
  workflowList: [],
  currentlyEditedWorkflow: {}
}

export default {
  namespaced: true,
  state: Object.assign({}, initialState),
  mutations: {
    resetStateData({ commit }) {
      commit('resetStateData')
    },
    setWorkflowList(state, data) {
      state.workflowList = data
    },
    setCurrentlyEditedWorkflow(state, data) {
      state.currentlyEditedWorkflow = data
    }
  },
  actions: {
    resetStateData({ commit }) {
      commit('resetStateData')
    },
    async getWorkflowsList({ dispatch, commit }, payload) {
      try {
        const res = await dispatch(
          'app/makeCall',
          {
            route: 'workflow.getWorkflowsList',
            payload
          },
          { root: true }
        )
        commit('setWorkflowList', res.data)
        return res.data
      } catch (error) {
        throw error.response
      }
    },
    setCurrentlyEditedWorkflow({ commit }, workflow) {
      commit('setCurrentlyEditedWorkflow', workflow)
    },
    async updateWorkflow({ dispatch }, { id, data }) {
      try {
        await dispatch(
          'app/makeCall',
          {
            route: 'workflow.updateWorkflow',
            payload: { id, data }
          },
          { root: true }
        )
      } catch (e) {
        throw e.response
      }
    },
    async createWorkflow({ dispatch }, payload) {
      try {
        await dispatch(
          'app/makeCall',
          {
            route: 'workflow.createWorkflow',
            payload
          },
          { root: true }
        )
      } catch (e) {
        throw e.response
      }
    },
    async deleteWorkflow({ dispatch }, payload) {
      try {
        await dispatch(
          'app/makeCall',
          {
            route: 'workflow.deleteWorkflow',
            payload
          },
          { root: true }
        )
      } catch (e) {
        throw e.response
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/workflow.js